import { useState } from "react";
import { api } from "../lib/api";

interface Result { total: number; imported: number; errors: Array<{ row: number; error: string }> }

const SAMPLE = "firstName,lastName,ndisNumber,email\nAda,King,431234567,ada@example.com";

export default function ImportParticipants({ onImported }: { onImported: () => void }) {
  const [csv, setCsv] = useState("");
  const [result, setResult] = useState<Result | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function run() {
    setError(null); setResult(null);
    try {
      const res = await api<Result>("/v1/migration/participants", { method: "POST", body: JSON.stringify({ csv }) });
      setResult(res); onImported();
    } catch (e) { setError((e as Error).message); }
  }

  return (
    <div className="card p-5 space-y-3">
      <p className="text-sm text-mut">Paste CSV with a header row: <code className="text-xs">firstName,lastName,ndisNumber,email,phone</code></p>
      <textarea rows={5} value={csv} onChange={(e) => setCsv(e.target.value)} placeholder={SAMPLE}
        className="input font-mono text-xs" />
      <div className="flex items-center gap-3">
        <button onClick={run} disabled={!csv.trim()} className="btn-dark disabled:opacity-50">Import</button>
        {error && <span className="text-sm text-red-600">{error}</span>}
      </div>
      {result && (
        <div className="text-sm">
          <p className="text-teal-700">Imported {result.imported} of {result.total} rows.</p>
          {result.errors.length > 0 && (
            <ul className="mt-1 text-red-600 list-disc pl-5">
              {result.errors.map((e) => <li key={e.row}>Row {e.row}: {e.error}</li>)}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}
